'use strict';

// import RenJS in a way that works in NodeJS and also the browser

const RenJSModule = require('@renproject/ren');
module.exports = RenJSModule.default.RenJS;
